import {assert} from 'assert-ts';
import {useAppSelector} from 'store/hooks';
import {useCreateSelectorById} from '../hooks/useCreateSelectorById';
import {selectMetadataEditMetadataManifestationById} from '../metadataEditSlice';
import type {ManifestationV4} from '../types';

export const useAssertManifestationEdit = (
  manifestationId: string,
): ManifestationV4 => {
  const selector = useCreateSelectorById(
    manifestationId,
    selectMetadataEditMetadataManifestationById,
  );
  const manifestation = useAppSelector(selector);
  if (!manifestation) {
    assert(false, 'useAsserManifestationEdit: no manifestation', {
      manifestationId,
    });
  }

  return manifestation;
};
